import { useEffect, useMemo, useState } from 'react';

const DEFAULT_PAGE_SIZE = 8;

function getItemsKey(items) {
  if (!items.length) {
    return '';
  }

  return items
    .map((item) => item.postId ?? item.postName ?? item.id ?? '')
    .join('|');
}

export function usePaginatedItems(items, itemsPerPage = DEFAULT_PAGE_SIZE) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsKey = useMemo(() => getItemsKey(items), [items]);

  const totalPages = Math.max(1, Math.ceil(items.length / itemsPerPage));
  const effectivePage = Math.min(Math.max(1, currentPage), totalPages);

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsKey]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const pageItems = useMemo(() => {
    const start = (effectivePage - 1) * itemsPerPage;
    return items.slice(start, start + itemsPerPage);
  }, [items, effectivePage, itemsPerPage]);

  const onPageChange = (_event, value) => {
    setCurrentPage(value);
  };

  return { pageItems, totalPages, currentPage: effectivePage, onPageChange };
}
